var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3342 16.6226H6.45441C6.07402 16.6226 5.76562 16.9309 5.76562 17.3113C5.76562 17.6917 6.07402 18.0001 6.45441 18.0001H11.3343C11.7146 18.0001 12.023 17.6917 12.023 17.3113C12.023 16.9309 11.7146 16.6226 11.3342 16.6226Z",
    fill: "#EBAFF5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3484 4.69954C17.0794 4.43056 16.6433 4.43056 16.3743 4.69954L13.0196 8.05428H1.138C0.757609 8.05428 0.449219 8.36267 0.449219 8.74306V10.4724C0.449219 13.379 2.81389 15.7436 5.72054 15.7436H12.0693C14.976 15.7436 17.3406 13.379 17.3406 10.4724V8.74306C17.3406 8.36267 17.0322 8.05428 16.6519 8.05428H14.9677L17.3484 5.67357C17.6174 5.40459 17.6174 4.96845 17.3484 4.69954Z",
    fill: "#EBAFF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66793 4.35962C5.4627 4.6659 5.46239 5.79603 4.66793 6.1022C3.9577 6.37586 4.1569 7.43381 4.91571 7.43381C5.43271 7.43381 6.64367 6.61865 6.64367 5.23089C6.64367 4.28213 6.04872 3.4155 5.16328 3.07424C4.36836 2.76789 4.36882 1.6379 5.16328 1.33165C5.51818 1.19486 5.69505 0.796186 5.55826 0.441249C5.42146 0.0862771 5.02272 -0.0904882 4.66789 0.0462342C3.78241 0.387495 3.1875 1.2542 3.1875 2.20289C3.1875 3.15158 3.78241 4.01836 4.66793 4.35962Z",
    fill: "#EBAFF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38465 4.35964C9.17943 4.66592 9.17911 5.79605 8.38465 6.10222C7.6745 6.37595 7.87376 7.43383 8.6325 7.43383C9.14958 7.43383 10.3604 6.61867 10.3604 5.23091C10.3604 4.28219 9.76552 3.41552 8.88004 3.07425C8.08526 2.76797 8.08558 1.63781 8.88004 1.33167C9.23498 1.19488 9.41185 0.796275 9.27512 0.441268C9.13833 0.0862606 8.73959 -0.0905047 8.38472 0.0462529C7.49924 0.387514 6.9043 1.25418 6.9043 2.20291C6.9043 3.15163 7.49921 4.01837 8.38465 4.35964Z",
    fill: "#EBAFF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoup);
export default __webpack_public_path__ + "static/media/soup.2cd86f8418e3e03fa30ca5ca7e4b7dfb.svg";
export { ForwardRef as ReactComponent };